import React from 'react'
import css from './Day.module.css'
import { IProtectionDayResponse } from 'screens/Protection/protection.types'
import cn from 'utils/cn'

type Props = {
  handleRedirect: (id: string) => void
  dayNumber: number
  isCurrentMonth: boolean
  protections: IProtectionDayResponse[]
  isToday?: boolean
  onClick?: (e: React.MouseEvent) => void
}

export default function Day({ handleRedirect, dayNumber, isCurrentMonth, protections, isToday, onClick }: Props) {
  return (
    <td
      onClick={onClick}
      className={cn(`
        ${css.day}
        ${!isCurrentMonth ? css.otherMonth : ''}
        ${isToday ? css.today : ''}
      `)}
    >
      <div className={css.content}>
        <div className={css.dayNumber}>{dayNumber}</div>

        {protections.map((protection) => (
          <div
            key={protection.id}
            className={css.event}
            onClick={(e) => {
              e.stopPropagation()
              handleRedirect(protection.id)
            }}
          >
            {protection.name}
          </div>
        ))}
      </div>
    </td>
  )
}
